const setAccount = (state, account) => {
  state.account = account;
};

const setRep = (state, rep) => {
  state.rep = rep;
};

const setCustomer = (state, customer) => {
  state.customer = customer;
};

const setInspector = (state, inspector) => {
  state.inspector = inspector;
};

const setPerson = (state, person) => {
  state.person = person;
};

const setLookupEmailLoading = (state, loading) => {
  state.lookupEmailLoading = loading;
};

const setFound = (state, found) => {
  state.found = found;
};

export default {
  setAccount,
  setRep,
  setCustomer,
  setInspector,
  setPerson,
  setLookupEmailLoading,
  setFound,
};
